import { formatDateTime } from 'utils/dates/date.utils';
import { hasValue } from '../../../../../../../utils/valueFormatting/display.utils';
import { airQualityForecastSubTab } from '../config/airQuality.config';

export const getAirQualityMode = (subtab) => {
  return subtab?.toLowerCase() === airQualityForecastSubTab ? 'forecast' : 'observations';
};

export const getAirQualityCardTitle = (item) => {
  return formatDateTime(item?.iso8601, 'short', 'Air Quality');
};

export const getAirQualityCardKey = (item, index) => {
  return [item?.air_station_name || item?.stationName, item?.iso8601, item?.category, index]
    .filter(hasValue)
    .join('-');
};

export const getAirQualityObservationCards = (observations = []) => {
  return observations.map((observation) => ({
    ...observation,
  }));
};

export const getAirQualityForecastStations = (stations = []) => {
  return stations.map((station) => {
    const stationName = station?.air_station_name || 'Unknown Station';
    const reports = station?.forecast_report ?? [];

    return {
      stationName,
      reports: reports.map((report) => ({
        ...report,
        air_station_name: stationName,
      })),
    };
  });
};
